var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"back display-flex",on:{"click":function($event){return _vm.onCloseHistory()}}},[_c('image-svg',{attrs:{"imageClass":_vm.imageClass,"imageName":_vm.imageName}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }